import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Typography } from '@mui/material'
import { Trans } from 'react-i18next'

/** Welcome page step component */
export const WelcomePageStep: React.FC = () => {
  const { t } = useCustomTranslation()

  return (
    <>
      <Trans i18nKey="emobility.tour.welcome-step-title" components={{ strong: <strong /> }} />
      <Typography mt={2}>{t('emobility.tour.welcome-step-content')}</Typography>
    </>
  )
}
